import React from 'react'
import {
  Paper,
} from 'material-ui';
import Container from 'components/Container'
import FormInput from 'components/forms/bases/FormInput'
import StateToolBar from 'components/bars/StateToolBar'
import { updateObject } from 'helpers/objectHelpers'
import { Grid } from 'semantic-ui-react'
import FormLevelCBanner from 'components/forms/FormLevelCBanner'

const TagBannerController = ({
  tagBanner,
  onChange,
  onSave,
  saveStatus,
  isStateChanged,
  setIsStateChanged,
  onDiscardChange,
}) => {
  const handleUpdate = (banner) => {
    if(banner.name) {
      setIsStateChanged(true)
    } else {
      setIsStateChanged(false)
    }
    return onChange(banner);
  }
  const handleUpdateByKey = (val, key) => {
    return handleUpdate(updateObject(tagBanner, { [key]: val }))
  }
  return (
    <div>
      <Container>
        <Paper>
          <StateToolBar
            primary={isStateChanged}
            isStateChanged={isStateChanged}
            onDiscard={() => {
              setIsStateChanged(false)
              return onDiscardChange()
            }}
            onSave={onSave}
            saveStatus={saveStatus}
          />
          <Grid columns={3} centered>
            <Grid.Column width={6}>
              <div style={{ padding: '30px 0', maxWidth: 300 }}>
                <FormInput
                  value={tagBanner.name || ''}
                  label={'Tag Name'}
                  onChange={(val) => handleUpdateByKey(val, 'name')}
                  {...!tagBanner.name && { errorText: 'This field is required.' }}
                />
              </div>
              <FormLevelCBanner
                value={tagBanner.data}
                onChange={(val) => handleUpdateByKey(val, 'data')}
              />
            </Grid.Column>
          </Grid>
        </Paper>
      </Container>
    </div>
  )
}

TagBannerController.propTypes = {}
TagBannerController.defaultProps = {}

export default TagBannerController



// WEBPACK FOOTER //
// ./src/pages/Banners/children/TagBanners/TagBannerController.js